// Valor por defecto cuando el tipo no es válido
export const DEFAULT_MICA_TYPE = 'UNKNOWN_TYPE'

// Valor por defecto para nombres vacíos
export const DEFAULT_SYSTEM_NAME = 'UNKNOWN_NAME'

// Valor por defecto para modelos vacíos
export const DEFAULT_SYSTEM_MODEL = 'UNKNOWN_MODEL'

export const DEFAULT_SERIAL_NUMBER = 'UNKNOWN_SN'
